import css from './GSTicketCard.module.scss'
import React, { useState } from 'react'
import classNames from 'classnames'
import { GoodTicketCode } from 'types/tickets'

import { IGoodServiceTicketData, Tap2GOTicketTicketStatus } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

import Img from 'components/Media/Img'

import NotValid from './Status/NotValid'
import Valid from './Status/Valid'
import Details from './Details'
import Header from './Header'

interface Props {
  showTap2GoModal: (show: boolean) => void
  showQRCodeModal: (show: boolean) => void
  showFullDescriptionModal: (show: boolean) => void
  data: IGoodServiceTicketData
}

const GSTicketCard: React.FC<Props> = (props) => {
  const { showTap2GoModal, showQRCodeModal, showFullDescriptionModal, data } = props

  const [showDetails, setShowDetails] = useState<boolean>(false)

  const isEventEnded = Dates.isAfter(new Date(), new Date(data.validTo_tz))

  const isTicketDrink = data?.event?.policy?.code == GoodTicketCode.drink

  return (
    <div className={css.wrapper}>
      <div className={css.ticketIcon}>
        {[Tap2GOTicketTicketStatus.valid, Tap2GOTicketTicketStatus.checked].includes(
          data.status as Tap2GOTicketTicketStatus
        )
          ? !showDetails && <Img src={`/goodsandservices/${data?.event?.policy?.code}-icon.svg`} />
          : !showDetails && (
              <Img
                src={`/goodsandservices/${isTicketDrink ? 'drink-icon-error.svg' : `${data?.event?.policy?.code}-icon.svg`}`}
              />
            )}
      </div>

      <button
        className={classNames(css.detailsIcon, { [css.goBack]: showDetails })}
        onClick={() => {
          setShowDetails(!showDetails)
        }}
      >
        {showDetails ? <Img src="/goodsandservices/arrow-circle-goback.svg" /> : <Img src="/icons/info_white.svg" />}
      </button>

      {!showDetails && (
        <>
          <Header data={data} showFullDescriptionModal={showFullDescriptionModal} />

          {data.status == Tap2GOTicketTicketStatus.valid && !isEventEnded ? (
            <Valid data={data} showTap2GoModal={showTap2GoModal} />
          ) : (
            <NotValid data={data} showQRCodeModal={showQRCodeModal} />
          )}
        </>
      )}

      {showDetails && <Details data={data} />}
    </div>
  )
}

export default GSTicketCard
